import styled from 'styled-components';
import { colors, spacing } from '../../../constants/theme';

// FlashCheck specific styled components that use the common UI library
export { 
  Container,
  ContentArea,
  ContentPadding,
  GridContainer as Grid,
  PageHeader,
  GradientTitle as PageTitle,
  BodyText as PageDescription
} from '../../../components/ui';

// Import common components with different names for backwards compatibility
export {
  TabButton as Tab,
  Card,
  CardIcon,
  CardTitle,
  CardDescription,
  Badge,
  EmptyState,
  EmptyIcon,
  EmptyStateTitle as EmptyTitle,
  EmptyStateDescription as EmptyDescription,
  FormContainer,
  FormGroup as InputGroup,
  Label,
  Input,
  TextArea,
  PrimaryButton as SubmitButton,
  StatusMessage as SuccessMessage,
  StatusMessage as ErrorMessage,
  Highlight
} from '../../../components/ui';

// Tab-specific component (not in common UI)
export const TabBar = styled.div`
  display: flex;
  background: ${colors.background.secondary};
  border-radius: 12px;
  padding: 4px;
  margin-top: ${spacing.sm};
  margin-bottom: ${spacing.sm};
  border: 1px solid ${colors.background.tertiary};
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  
  @media (max-width: 768px) {
    margin-top: ${spacing.xs};
    margin-bottom: ${spacing.xs};
    padding: 3px;
    border-radius: 8px;
  }
`;
